import * as React from 'react';
import { useConfig, useContractContext } from 'src/providers';

export interface ILinkContext {
  clydeLogo: string | false; // FALSE = don't make it clickable
  terms: string;
  learnMore: string;
}

// TODO: fail loudly if these are empty at runtime?
export const LinkContext = React.createContext<ILinkContext>({
  clydeLogo: '',
  terms: '',
  learnMore: '',
});

interface IProps {
  children: React.ReactNode;
}

export const LinkProvider = ({ children }: IProps) => {
  const { customText, showXCoverBranding } = useConfig();
  const { contracts } = useContractContext();

  const [clydeLogo, setClydeLogo] = React.useState<string | false>('https://www.hiclyde.com/login');
  const [terms, setTerms] = React.useState('');
  const [learnMore, setLearnMore] = React.useState('');

  React.useEffect(() => {
    const { logoLink, contractLink, learnMoreLink } = customText;

    if (logoLink && logoLink.trim() !== '' && logoLink.startsWith('http')) {
      setClydeLogo(logoLink);
    } else if (logoLink === 'NONE') {
      setClydeLogo(false);
    } else if (showXCoverBranding) {
      setClydeLogo('https://www.xcover.com/');
    }

    const termsLink = contractLink || contracts[0]?.link;
    if (termsLink) {
      setTerms(termsLink);
    } else {
      // TODO: honeybadger?
    }

    if (learnMoreLink) {
      setLearnMore(learnMoreLink);
    } else if (termsLink) {
      setLearnMore(termsLink);
    } else {
      // TODO: honeybadger?
    }
  }, [customText, contracts]);

  const value = {
    clydeLogo,
    terms,
    learnMore,
  };

  return <LinkContext.Provider value={value}>{children}</LinkContext.Provider>;
};

export const useLinks = () => React.useContext(LinkContext);
